// Texty zvýraznených recenzií na detaile produktu (reviewHighlights.js, recenze U3).
import { plural } from '../plural.js';

export default {
  title: 'Recenzie zákazníkov',
  buyersTitle: 'Zákazníci, ktorí kúpili tento produkt',
  buyersSub: 'Hodnotia nákup v našom obchode.',
  buyersSubFirst: 'Hodnotia nákup v našom obchode. Recenziu produktu zatiaľ nikto nenapísal.',
  shopTitle: (shop) => 'Hodnotenie obchodu ' + shop,
  shopSub: 'Hodnotia nákup v našom obchode.',
  shopSubFirst: 'Recenziu tohto produktu zatiaľ nikto nenapísal.',
  ratings: (n, count) => n + ' ' + plural(count, ['hodnotenie', 'hodnotenia', 'hodnotení']),
  shopRatings: (n, count) => n + ' ' + plural(count, ['hodnotenie obchodu', 'hodnotenia obchodu', 'hodnotení obchodu']),
  share: (pct) => pct + '\u00A0% dáva 4 a viac hviezdičiek',
  allReviews: (n, count) => plural(count, ['Zobraziť recenziu', 'Všetky ' + n + ' recenzie', 'Všetkých ' + n + ' recenzií']),
  allRatings: 'Všetky hodnotenia',
  moreBuyers: (n, count) => plural(count, ['Ďalšie ' + n + ' hodnotenie od kupujúcich', 'Ďalšie ' + n + ' hodnotenia od kupujúcich', 'Ďalších ' + n + ' hodnotení od kupujúcich']),
  allShopRatings: 'Všetky hodnotenia obchodu',
  firstReview: 'Máte ho doma? Napíšte prvú recenziu',
  writeReview: 'Napíšte recenziu',
  verify: 'Ako recenzie overujeme',
  verifyShort: 'Ako overujeme',
  sourceHeureka: 'Overené Heurekou',
  sourceWeb: (shop) => 'Recenzia na ' + shop,
  buyerHeureka: 'Kúpil tento produkt · overené Heurekou',
  buyer: 'Kúpil tento produkt',
  shopHeureka: 'Hodnotenie obchodu · overené Heurekou',
  shopLabel: 'Hodnotenie obchodu',
  more: (n, count) => plural(count, ['ďalšia ' + n, 'ďalšie ' + n, 'ďalších ' + n]),
  moreNoun: (count) => plural(count, ['recenzia', 'recenzie', 'recenzií']),
  starsAria: (n) => n + ' z 5 hviezdičiek',
};
